import * as React from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'

import { TeamDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

const TeamModal = ({ modalComponent: Modal }: { modalComponent: React.ElementType }) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { company } = useCurrentSession()
  const { id } = useParams<{ id: string }>()
  const { data } = useQuery(TeamDocument, {
    variables: {
      teamId: Number(id),
      companyId: company.id,
    },
    fetchPolicy: 'cache-first',
  })
  const team = data?.teams.team
  const canManageTeams = data?.teams._policies.teamManage.can

  if (!team) {
    return null
  }

  if (!canManageTeams) {
    return <Navigate to={navigation.employees.teams.list.path} />
  }

  return (
    <Modal
      team={team}
      onClose={() => {
        navigate('..')
      }}
    />
  )
}

export default TeamModal
